module.exports = __webpack_public_path__ + "img/supplier-006.80cc7081.png";